import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { TextInput } from '@prisjakt/ui-inputs';
import { media, layout, colors, remCalc } from '@prisjakt/ui-base';
import SubmitButton from '../components/submit-button';

const spacerHeight = '20px';
const spacerHeightExtra = '30px';
const gutter = remCalc(10);

export const LoginPage = styled.div`
  display: flex;

  ${media.mediumDown`
    flex-direction: column;
  `}

  ${media.mediumUp`
    flex-direction: row;
    margin-bottom: ${spacerHeightExtra}
  `}
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;

  &:first-of-type {
    margin-top: ${spacerHeight};
    padding-left: ${gutter};
    padding-right: ${gutter};

    ${media.mediumDown`
      width: 100%;
      margin-bottom: ${remCalc(15)};
      padding-bottom: ${remCalc(15)};
      border-bottom: 1px solid ${p => p.theme.lines.primary};
    `}

    ${media.mediumUp`
      width: 50%;
      padding-right: ${layout.margins.component.desktop.rem};
      border-right: 1px solid ${p => p.theme.lines.primary};
    `}
  }

  &:last-of-type {
    margin-top: ${spacerHeight};
    padding-left: ${gutter};
    padding-right: ${gutter};

    ${media.mediumDown`
      width: 100%;
      margin-top: ${remCalc(15)};
      margin-bottom: ${remCalc(15)};
    `}

    ${media.mediumUp`
      width: 50%;
      padding-left: ${layout.margins.component.mobile.rem};
    `}
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

export const FormError = styled.div`
  margin-top: ${spacerHeight};
  color: ${colors.red1};
`;

export const LoginButton = styled(SubmitButton)`
  margin-top: ${spacerHeightExtra};
`;

export const ForgotPasswordLink = styled(Link)`
  margin-top: ${spacerHeight};
`;

export const EmailInput = styled(TextInput)``;

export const PasswordInput = styled(TextInput)`
  margin-top: ${spacerHeight};
`;

export const Spacer = styled.div`
  margin-top: ${props => (props.extra ? spacerHeightExtra : spacerHeight)};
`;

export const LinkText = styled.div`
  color: ${p => p.theme.text.callToAction};
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
  }
`;

export const Description = styled.div`
  margin: ${spacerHeightExtra} ${remCalc(15)} ${remCalc(15)} ${remCalc(15)};
  text-align: center;
`;
